import { createRouter, createWebHistory } from 'vue-router';

const routes = [
  {
    path: '/home',
    name: 'Home',
    component: ()=>import('../view/home'),
    meta: {
      title: '主页',
    },
  },
  {
    name: 'Login',
    path: '/login',
    component: () => import('../view/login.vue'),
    meta: {
      title: '登录',
    },
  },
  {
    path: '/',
    name: 'layout',
    component: ()=>import('../view/layout'),
    // ⚠️ 这一行不能删（2026-10-06 补）：
    //   layout 的子路由**全是绝对路径**（/order、/investment…），没有 `path: ''` 的
    //   index 子路由。所以访问 `/` 时 layout 会正常渲染，但里面的 <router-view />
    //   匹配不到任何子路由 → 页面只剩一条深红导航栏 + 空白内容（提审前实测踩到）。
    //   以前之所以没暴露：登录态存在 sessionStorage，web-view 每次重开都被守卫踢到
    //   /login，「带登录态访问 /」这条路径几乎没人走到。改存 localStorage 后，
    //   重进小程序直接命中 `/`，空白页立刻现形。
    redirect: '/home',
    children: [
      {
        name: 'Order',
        path: '/order',
        component: () => import('../view/order'),
        meta: {
          title: '订单管理',
        },
      },
      {
        name: 'Design',
        path: '/design',
        component: () => import('../view/design'),
        meta: {
          title: '设计管理',
        },
      },
      {
        name: 'Logistics',
        path: '/logistics',
        component: () => import('../view/logistics'),
        meta: {
          title: '物流管理',
        },
      },
      {
        name: 'Production',
        path: '/production',
        component: () => import('../view/production'),
        meta: {
          title: '生产管理',
        },
      },
      {
        name: 'DevOps',
        path: '/devOps',
        component: () => import('../view/devOps'),
        meta: {
          title: '运维管理',
        },
      },
      {
        name: 'Collection',
        path: '/collection',
        component: () => import('../view/collection'),
        meta: {
          title: '账单审批',
        },
      },
      {
        name: 'Goods',
        path: '/goods',
        component: () => import('../view/goods'),
        meta: {
          title: '商品管理',
        },
      },
      {
        name: 'User',
        path: '/user',
        component: () => import('../view/user'),
        meta: {
          title: '职工管理',
        },
      },
      {
        name: 'Statistics',
        path: '/statistics',
        component: () => import('../view/statistics'),
        meta: {
          title: '销售统计',
        },
      },
      {
        name: 'Salary',
        path: '/salary',
        component: () => import('../view/salary'),
        meta: {
          title: '薪资管理',
        },
      },
      {
        name: 'Investment',
        path: '/investment',
        component: () => import('../view/investment'),
        meta: {
          title: '投资专栏',
        },
      }
    ]
  },
  {
    // 兜底：任何未知路径都不要留白屏。
    // 必须放在最后（vue-router 按顺序匹配，/login 等已在上方命中）。
    // 未登录时守卫会把它再踢到 /login，所以直接指向 /home 是安全的。
    path: '/:pathMatch(.*)*',
    redirect: '/home',
  }

];

const router = createRouter({
  routes,
  history: createWebHistory(process.env.BASE_URL),
});

router.beforeEach((to, from, next) => {
  if (to.path === '/login') {
    next()
    return
  }
  // 登录态存 localStorage（不能用 sessionStorage：web-view 每次重开都会清空 → 反复要求登录）
  let user = localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")) : {}
  if (!user.permissions || !user.permissions.length) {
    next('/login')
  } else {
    next()
  }
});

export { router };
